"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var shapes = _interopRequireWildcard(require("./shapes"));

var _editorReducer = _interopRequireWildcard(require("./editorReducer"));

var _Sheet = _interopRequireDefault(require("./Sheet"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var DatasheetEditor =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DatasheetEditor, _PureComponent);

  function DatasheetEditor() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DatasheetEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DatasheetEditor)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastState", _this.props.editorState);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dispatch", function (action) {
      var onChange = _this.props.onChange;
      var prevState = _this.lastState;
      var state = (0, _editorReducer.default)(prevState, action);

      if (prevState !== state) {
        _this.lastState = state;
        onChange(state);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(DatasheetEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var editorState = this.props.editorState;

      if (editorState !== prevProps.editorState) {
        this.lastState = editorState;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          additionalColumns = _this$props.additionalColumns,
          editorState = _this$props.editorState,
          name = _this$props.name,
          optionalColumns = _this$props.optionalColumns,
          requiredColumns = _this$props.requiredColumns,
          onChange = _this$props.onChange,
          readOnly = _this$props.readOnly,
          allowColumnAddRemove = _this$props.allowColumnAddRemove;
      var columns = editorState.columns,
          rows = editorState.rows,
          selection = editorState.selection,
          editing = editorState.editing;
      var defaultedRequiredColumns = requiredColumns || columns;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Toolbar.default, {
        additionalColumns: additionalColumns,
        columns: columns,
        dispatch: this.dispatch,
        name: name,
        optionalColumns: optionalColumns,
        requiredColumns: defaultedRequiredColumns,
        rows: rows,
        selection: selection,
        readOnly: readOnly,
        allowColumnAddRemove: allowColumnAddRemove
      }), _react.default.createElement(_Sheet.default, {
        columns: columns,
        dispatch: this.dispatch,
        editing: editing,
        rows: rows,
        selection: selection,
        onChange: onChange,
        readOnly: readOnly
      }));
    }
  }]);
  return DatasheetEditor;
}(_react.PureComponent);

exports.default = DatasheetEditor;
(0, _defineProperty2.default)(DatasheetEditor, "defaultProps", {
  additionalColumns: 'allow',
  name: '',
  optionalColumns: [],
  requiredColumns: null,
  readOnly: false,
  allowColumnAddRemove: false
});
(0, _defineProperty2.default)(DatasheetEditor, "propTypes", {
  additionalColumns: shapes.additionalColumns,
  editorState: shapes.editorState.isRequired,
  name: _propTypes.default.string,
  optionalColumns: _propTypes.default.arrayOf(shapes.column),
  requiredColumns: _propTypes.default.arrayOf(shapes.column),
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  allowColumnAddRemove: _propTypes.default.bool
});
(0, _defineProperty2.default)(DatasheetEditor, "createEditorState", function (rows, columns) {
  return (0, _editorReducer.defaultState)(columns, rows);
});
(0, _defineProperty2.default)(DatasheetEditor, "getColumns", function (editorState) {
  return editorState.columns;
});
(0, _defineProperty2.default)(DatasheetEditor, "getRows", function (editorState) {
  return editorState.rows;
});